module.exports = __webpack_public_path__ + "static/media/icon_info.8832f522.svg";